<!-- 账户管理 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    @click="goModal"
                    >新增账号</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="title">
                        <div>
                            {{
                                row.relation.length
                                    ? row.relation[0].group.title
                                    : ""
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1">正常</div>
                        <div v-if="row.status == 0">禁用</div>
                    </template>
                    <template
                        slot-scope="{ row }"
                        slot="is_association"
                    >
                        <button
                            class="association-btn"
                            v-if="
                                row.agent_relation_count ||
                                row.store_relation_count ||
                                row.product_relation_count
                            "
                            @click="goAssociation(row)"
                        >
                            {{ getRelationText(row) }}
                        </button>
                        <button
                            class="association-btn"
                            v-else
                            @click="goAssociation(row)"
                        >
                            选择数据关联
                        </button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="primary" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button
                                v-if="row.status == 1"
                                type="primary"
                                ghost
                                @click="changeStatus(row)"
                                >禁用</Button
                            >
                            <Button
                                v-if="row.status == 0"
                                type="success"
                                ghost
                                @click="changeStatus(row)"
                                >启用</Button
                            >
                            <Button type="error" ghost @click="goDel(row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="mt24 ta-r">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    ref="formData"
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    :rules="ruleValidate"
                >
                    <FormItem label="账户名称：" prop="user">
                        <Input
                            type="text"
                            v-model="formData.user"
                            placeholder="请输入账户名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="手机号：" prop="phone">
                        <Input
                            type="text"
                            v-model="formData.phone"
                            placeholder="请输入手机号"
                        ></Input>
                    </FormItem>
                    <FormItem label="密码：" prop="password">
                        <Input
                            type="password"
                            v-model="formData.password"
                            placeholder="请输入密码"
                        ></Input>
                    </FormItem>
                    <FormItem  label="质保卡激活权限：">
                        <i-switch
                            v-model="formData.activate_warranty"
                            size="large"
                            true-color="var(--primary-color) "
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="分配角色：" prop="group">
                        <CheckboxGroup
                            v-model="formData.group"
                            v-for="(item, index) in roleList"
                            :key="index"
                        >
                            <Checkbox :label="item.id + ''"
                                ><span>{{ item.title }}</span></Checkbox
                            >
                        </CheckboxGroup>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelForm">取消</Button>
                <Button
                    class="theme-bc ml24 theme-default-color"
                    @click="submitForm"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 数据关联 -->
        <Drawer v-model="info_model" title="数据关联" width="40">
            <div class="drawer-content">
                <Tabs :value="info_data.template_value" @on-click="handleTabChange" animated>
                    <TabPane label="经销商" name="1">
                        <div class="tab-container">
                            <div class="info-header">
                                <Input
                                    class="w300 mr24 mb24"
                                    type="text"
                                    v-model="info_data.agent_keywords"
                                    placeholder="搜索"
                                    clearable
                                ></Input>
                                <Button
                                    class="theme-bc mb24 theme-default-color"
                                    icon="ios-search"
                                    @click="goSearch"
                                    >确认搜索</Button
                                >
                            </div>
                            <div class="table-wrapper">
                                <Table
                                    ref="agentSelection"
                                    :columns="agentColumns"
                                    :data="agentData"
                                    border
                                    @on-select="onAgentSelect"
                                    @on-select-cancel="onAgentSelectCancel"
                                    @on-selection-change="changeAgentSelection"
                                >
                                </Table>
                            </div>
                            <div class="info-footer">
                                <Button
                                    class="theme-bc theme-default-color ml12"
                                    @click="submitAgent"
                                    >确定</Button
                                >
                            </div>
                        </div>
                    </TabPane>
                    <TabPane label="门店" name="2">
                        <div class="tab-container">
                            <div class="info-header">
                                <Input
                                    class="w300 mr24 mb24"
                                    type="text"
                                    v-model="info_data.store_keywords"
                                    placeholder="搜索"
                                    clearable
                                ></Input>
                                <Button
                                    class="theme-bc mb24 theme-default-color"
                                    icon="ios-search"
                                    @click="goSearch"
                                    >确认搜索</Button
                                >
                            </div>
                            <div class="table-wrapper">
                                <Table
                                    ref="storeSelection"
                                    :columns="storeColumns"
                                    :data="storeData"
                                    border
                                    @on-select="onStoreSelect"
                                    @on-select-cancel="onStoreSelectCancel"
                                    @on-selection-change="changeStoreSelection"
                                >
                                </Table>
                            </div>
                            <div class="info-footer">
                                <Button
                                    class="theme-bc theme-default-color ml12"
                                    @click="submitStore"
                                    >确定</Button
                                >
                            </div>
                        </div>
                    </TabPane>
                    <TabPane label="产品" name="3">
                        <div class="tab-container">
                            <div class="info-header">
                                <Input
                                    class="w300 mr24 mb24"
                                    type="text"
                                    v-model="info_data.product_keywords"
                                    placeholder="搜索"
                                    clearable
                                ></Input>
                                <Button
                                    class="theme-bc mb24 theme-default-color"
                                    icon="ios-search"
                                    @click="goSearch"
                                    >确认搜索</Button
                                >
                            </div>
                            <div class="table-wrapper">
                                <Table
                                    ref="productSelection"
                                    :columns="productColumns"
                                    :data="productData"
                                    border
                                    @on-select="onProductSelect"
                                    @on-select-cancel="onProductSelectCancel"
                                    @on-selection-change="changeProductSelection"
                                >
                                </Table>
                            </div>
                            <div class="info-footer">
                                <Button
                                    class="theme-bc theme-default-color ml12"
                                    @click="submitProduct"
                                    >确定</Button
                                >
                            </div>
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        </Drawer>
    </div>
</template>

<script>
import {
    account_list,
    account_save,
    account_status,
    account_delete,
    account_roles_select,
    product_relation_list,
    account_relation_agent,
    account_relation_store,
    account_relation_product,
} from "@/api/index";
import { getStorages } from "@/utils/helper";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "账户名称", key: "user", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "角色名称", slot: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "数据关联", slot: "is_association", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            formData: {
                id: "",
                user: "",
                password: "",
                phone: "",
                group: [],
                activate_warranty: 0,
            },
            ruleValidate: {
                user: [
                    {
                        required: true,
                        message: "请输入账户名称",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                ],
            },
            roleList: [],
            info_model: false,
            info_data: {
                template_value: "1",
                user_id: "",
                page: 1,
                limit: 999,
                agent_keywords: "",
                store_keywords: "",
                product_keywords: "",
            },
            // 经销商数据
            agentData: [],
            agentColumns: [
                { type: "selection", align: "center", width: 100 },
                { title: "ID", key: "id", align: "center" },
                { title: "经销商名称", key: "agent_name", align: "center" },
            ],
            agentDelData: [],
            // 门店数据
            storeData: [],
            storeColumns: [
                { type: "selection", align: "center", width: 100 },
                { title: "ID", key: "id", align: "center" },
                { title: "门店名称", key: "name", align: "center" },
            ],
            storeDelData: [],
            // 产品数据
            productData: [],
            productColumns: [
                { type: "selection", align: "center", width: 100 },
                { title: "ID", key: "id", align: "center" },
                { title: "产品名称", key: "product_name", align: "center" },
            ],
            productDelData: [],
            infos:getStorages('infos')
        };
    },
    created() {
        
    },
    mounted() {
        this.getList();
        this.getAccountRolesSelect();
    },
    methods: {
        getList() {
            account_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        getAccountRolesSelect() {
            account_roles_select()
                .then((res) => {
                    this.roleList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Modal
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑账号";
                this.formData.id = row.id;
                this.formData.user = row.user;
                this.formData.phone = row.phone;
                this.formData.group = row.group;
                this.formData.activate_warranty = row.activate_warranty;
            } else {
                this.modalTitle = "新增账号";
                this.formData.id = "";
                this.formData.user = "";
                this.formData.password = "";
                this.formData.phone = "";
                this.formData.group = [];
                this.formData.activate_warranty = 0;
            }
            this.modals = true;
        },
        cancelForm() {
            this.modals = false;
        },
        // 确定（提交表单）
        submitForm() {
            if (!this.formData.group.length) {
                this.$Message.error("请选择分配角色");
                return;
            }
            const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!phoneReg.test(this.formData.phone)) {
                this.$Message.error("请输入正确的手机号码");
                return;
            }
            account_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 修改账户状态
        changeStatus(row) {
            this.$Modal.confirm({
                title: "修改提示",
                content: "确认修改账户状态吗？",
                onOk: () => {
                    account_status({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    account_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goAssociation(row) {
            this.info_data.template_value = "1";
            this.info_data.user_id = row.id;
            this.info_data.page = 1;
            this.info_data.keywords = "";
            this.agentData = [];
            this.agentDelData = [];
            this.storeData = [];
            this.storeDelData = [];
            this.productData = [];
            this.productDelData = [];
            this.getRelationList();
            this.info_model = true;
        },
        // 提交经销商关联
        submitAgent() {
            var ids = this.agentDelData
                .filter((item) => item && item.id !== undefined && item.id !== null)
                .map((item) => item.id);
            var data = {
                user_id: this.info_data.user_id,
                ids: ids,
            };
            account_relation_agent(data)
                .then((res) => {
                    this.getList();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 提交门店关联
        submitStore() {
            var ids = this.storeDelData
                .filter((item) => item && item.id !== undefined && item.id !== null)
                .map((item) => item.id);
            var data = {
                user_id: this.info_data.user_id,
                ids: ids,
            };
            account_relation_store(data)
                .then((res) => {
                    this.getList();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 提交产品关联
        submitProduct() {
            var ids = this.productDelData
                .filter((item) => item && item.id !== undefined && item.id !== null)
                .map((item) => item.id);
            var data = {
                user_id: this.info_data.user_id,
                ids: ids,
            };
            account_relation_product(data)
                .then((res) => {
                    this.getList();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 获取关联列表（一次性获取所有数据）
        getRelationList() {
            var data = {
                user_id: this.info_data.user_id,
                page: this.info_data.page,
                agent_keywords: this.info_data.agent_keywords,
                store_keywords: this.info_data.store_keywords,
                product_keywords: this.info_data.product_keywords,
            };
            product_relation_list(data)
                .then((res) => {
                    // 经销商
                    this.agentData = res.data.partner || [];
                    this.agentDelData = [];
                    // 门店
                    this.storeData = res.data.shop || [];
                    this.storeDelData = [];
                    // 产品
                    this.productData = res.data.items || [];
                    this.productDelData = [];
                    // 等待数据渲染完成后设置选中状态
                    // 由于添加了animated属性，所有Tab的DOM都会提前渲染
                    // 增加延迟时间确保所有Tab的checkbox都已渲染完成
                    setTimeout(() => {
                        this.setAgentChecked();
                        this.setStoreChecked();
                        this.setProductChecked();
                    }, 500);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 设置经销商已关联的行默认选中
        setAgentChecked() {
            this.$nextTick(() => {
                if (!this.$refs.agentSelection) return;
                const checkboxes = this.$refs.agentSelection.$el.querySelectorAll('.ivu-table-body input[type="checkbox"]');
                this.agentData.forEach((row, index) => {
                    if (row.has_relation == 1) {
                        // 同步更新DelData
                        if (!this.agentDelData.find(item => item.id == row.id)) {
                            this.agentDelData.push(row);
                        }
                        // 触发checkbox选中
                        if (checkboxes[index] && !checkboxes[index].checked) {
                            checkboxes[index].click();
                        }
                    }
                });
            });
        },
        // 设置门店已关联的行默认选中
        setStoreChecked() {
            this.$nextTick(() => {
                if (!this.$refs.storeSelection) return;
                const checkboxes = this.$refs.storeSelection.$el.querySelectorAll('.ivu-table-body input[type="checkbox"]');
                this.storeData.forEach((row, index) => {
                    if (row.has_relation == 1) {
                        // 同步更新DelData
                        if (!this.storeDelData.find(item => item.id == row.id)) {
                            this.storeDelData.push(row);
                        }
                        // 触发checkbox选中
                        if (checkboxes[index] && !checkboxes[index].checked) {
                            checkboxes[index].click();
                        }
                    }
                });
            });
        },
        // 设置产品已关联的行默认选中
        setProductChecked() {
            this.$nextTick(() => {
                if (!this.$refs.productSelection) return;
                const checkboxes = this.$refs.productSelection.$el.querySelectorAll('.ivu-table-body input[type="checkbox"]');
                this.productData.forEach((row, index) => {
                    if (row.has_relation == 1) {
                        // 同步更新DelData
                        if (!this.productDelData.find(item => item.id == row.id)) {
                            this.productDelData.push(row);
                        }
                        // 触发checkbox选中
                        if (checkboxes[index] && !checkboxes[index].checked) {
                            checkboxes[index].click();
                        }
                    }
                });
            });
        },
        // 经销商选中事件
        changeAgentSelection(selection) {
            this.agentDelData = selection;
        },
        // 门店选中事件
        changeStoreSelection(selection) {
            this.storeDelData = selection;
        },
        // 产品选中事件
        changeProductSelection(selection) {
            this.productDelData = selection;
        },
        // 经销商单选
        onAgentSelect(selection, row) {
            if (row.has_relation == 1 && !this.agentDelData.find(item => item.id == row.id)) {
                this.agentDelData.push(row);
            }
        },
        onAgentSelectCancel(selection, row) {
            this.agentDelData = this.agentDelData.filter(item => item.id != row.id);
        },
        // 门店单选
        onStoreSelect(selection, row) {
            if (row.has_relation == 1 && !this.storeDelData.find(item => item.id == row.id)) {
                this.storeDelData.push(row);
            }
        },
        onStoreSelectCancel(selection, row) {
            this.storeDelData = this.storeDelData.filter(item => item.id != row.id);
        },
        // 产品单选
        onProductSelect(selection, row) {
            if (row.has_relation == 1 && !this.productDelData.find(item => item.id == row.id)) {
                this.productDelData.push(row);
            }
        },
        onProductSelectCancel(selection, row) {
            this.productDelData = this.productDelData.filter(item => item.id != row.id);
        },
        goSearch() {
            this.info_data.page = 1;
            this.getRelationList();
        },
        // Tab 切换时设置选中状态
        handleTabChange(name) {
            this.info_data.template_value = name;
            // 切换 Tab 时，如果对应类型数据为空，则请求数据
            if (!this.agentData.length && !this.storeData.length && !this.productData.length) {
                this.getRelationList();
            } else {
                // 数据已加载，设置当前 Tab 的选中状态
                // 由于iView的懒加载机制，非活动Tab的DOM可能还未渲染
                // 需要在切换后延迟执行以确保DOM已渲染
                setTimeout(() => {
                    if (name == "1") {
                        this.setAgentChecked();
                    } else if (name == "2") {
                        this.setStoreChecked();
                    } else if (name == "3") {
                        this.setProductChecked();
                    }
                }, 300);
            }
        },
        getRelationText(row) {
            // 1. 初始化数组，存放所有有值的文本片段
            const relationParts = [];
            // 2. 逐个判断，有值则添加纯文本片段（不再手动加 /）
            if (row.agent_relation_count) {
                relationParts.push(`经销商(${row.agent_relation_count})`);
            }
            if (row.store_relation_count) {
                relationParts.push(`门店(${row.store_relation_count})`);
            }
            if (row.product_relation_count) {
                relationParts.push(`产品(${row.product_relation_count})`);
            }
            // 3. 用 / 连接数组中的所有片段，无数据则返回空字符串
            return relationParts.join("&");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
}
.ta-r {
    text-align: right;
}
.info-footer {
    text-align: right;
    margin-top: 16px;
    padding: 12px 0;
}
.info-header {
    margin: 12px 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-shrink: 0;
}
/* Drawer内容区域样式 */
.drawer-content {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.tab-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 150px);
    min-height: 300px;
}
.table-wrapper {
    flex: 1;
    overflow-y: auto;
    min-height: 200px;
}
::v-deep .table-wrapper .ivu-table-wrapper {
    height: 100% !important;
}
::v-deep .table-wrapper .ivu-table-body {
    overflow-y: auto;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox {
    margin-right: 12px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-menu-item {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #484e66;
}
::v-deep .ivu-menu-item:hover {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: var(--primary-color) !important;
    border-bottom: 2px solid var(--primary-color) !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: var(--primary-color) !important;
    border-bottom: 2px solid var(--primary-color) !important;
}
/* 数据关联按钮样式 */
.association-btn {
    background: var(--primary-color);
    color: #fff;
    border: none;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
}
.association-btn:hover {
    opacity: 0.85;
}
</style>